import { Button, TableColumnType } from "antd";
import moment from "moment";
import React, { ReactElement } from "react";
import { Dimen } from "../../models/dimen";
import { StateSwitch } from "../../compnents/widgets/StateSwitch";
import { useSelector } from "react-redux";
import { selectTenantCategory } from "../../app/applicationSlice";

export const ReportCardColumns = (
  onAction: (v: string, data: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  const tenantCategory = useSelector(selectTenantCategory)
  const columns: TableColumnType<any>[] =  [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "机构名称",
      align: "center",
      width: Dimen.PatientPhone,
      dataIndex: "applicantOrgName",
      key: "applicantOrgName",
    },
    {
      title: "报卡编码",
      align: "center",
      width: Dimen.Num,
      dataIndex: "code",
      key: "code",
    },
    {
      title: "报卡类别",
      key: "categoryName",
      dataIndex: "categoryName",
      align: "center",
      width: Dimen.Num,
    },
    {
      title: "患者姓名",
      key: "patientName",
      dataIndex: "patientName",
      align: "center",
      width: Dimen.Num,
    },
    {
      title: "性别",
      key: "sexName",
      dataIndex: "sexName",
      align: "center",
      width: Dimen.Num,
    },
    {
      title: "年龄",
      key: "age",
      dataIndex: "age",
      align: "center",
      width: Dimen.Num,
    },
    {
      title: "联系方式",
      key: "tel",
      dataIndex: "tel",
      align: "center",
      width: Dimen.Num,
    },
    {
      title: "身份证号",
      key: "idCard",
      dataIndex: "idCard",
      align: "center",
      width: Dimen.Status,
    },
    {
      title: "就诊时间",
      key: "diagnosisDate",
      dataIndex: "diagnosisDate",
      align: "center",
      width: Dimen.Num,
      render: (_, t) => {
        return t?.diagnosisDate ? moment(t?.diagnosisDate).format("YYYY-MM-DD HH时") : ''
      },
    },
    {
      title: "病历分类",
      key: "firstCaseClassificationName",
      dataIndex: "firstCaseClassificationName",
      align: "center",
      width: Dimen.Num,
    },
    {
      title: "传染病名称",
      key: "diseaseName",
      dataIndex: "diseaseName",
      align: "center",
      width: Dimen.Num,
    },
    {
      title: "填卡医生",
      key: "reportDoctor",
      dataIndex: "reportDoctor",
      align: "center",
      width: Dimen.Num,
    },
    {
      title: "填卡时间",
      key: "reportTime",
      dataIndex: "reportTime",
      align: "center",
      width: Dimen.Num,
      render: (_, t) => {
        return t?.reportTime ? moment(t?.reportTime).format("YYYY-MM-DD HH:mm") : ''
      },
    },
    {
      title: "报卡状态",
      key: "reportStatusName",
      dataIndex: "reportStatusName",
      align: "center",
      width: Dimen.Num,
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '6rem',
      fixed: 'right',
      render: function ShowAction(_, t): ReactElement {
        return (
          <>
            <Button
              type='link'
              onClick={() => onAction && onAction('detail', t)}
            >
              详情
            </Button>
            {t?.reportStatus == '0' &&<>
              {tenantCategory == 6 && <Button
                type='link'
                onClick={() => onAction && onAction('accept', t)}
              >
                审核
              </Button>}
              {tenantCategory != 6 &&<Button
                type='link'
                danger
                onClick={() => onAction && onAction('revoke', t)}
              >
                撤销
              </Button>}
            </>}
          </>
        )
      },
    },
  ]

  return tenantCategory == 6 ? columns : columns.filter(c => c.key !== 'applicantOrgName')
}
